export default __webpack_public_path__ + "bcbb79d81ba4b0312baefc0175c9e016.svg";